import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CaptainDAO } from '../../../../../core/services/dao/captainDAO';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { Router } from '@angular/router';
import { ConstantMan } from '../../../../../core/services/constantMan';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
})
export class AddressComponent implements OnInit, OnDestroy {
  @Input() title: string;

  @Input() captain: Captain;

  @Input() newCaptain: boolean;

  @Input() adminAccess: boolean;

  @Input() ownerComponent: boolean;

  @Output() onCancelled = new EventEmitter<boolean>();
  @Output() onSubmitted = new EventEmitter<any>();
  model: Captain;
  zipPattern = ConstantMan.PATTERNS.ZIP;
  public stateList = [
    'AK',
    'AL',
    'AR',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MI',
    'MN',
    'MO',
    'MS',
    'MT',
    'NC',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NM',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'VT',
    'WA',
    'WI',
    'WV',
    'WY',
  ];

  constructor(
    private captainDAO: CaptainDAO,
    private userDAO: UserDAO,
    private router: Router,
  ) {}

  ngOnInit() {
    this.model = this.captain;
  }

  ngOnDestroy(): void {}

  onSubmit() {
    this.onSubmitted.emit(this.model);
  }

  cancel() {
    console.log('cancel');
  }
}
